import {
  FacebookIcon,
  WhatsAppIcon,
  XIcon,
  InstagramIcon,
  YoutubeIcon,
  TwitchIcon,
  TikTokIcon,
} from 'icons';

export const socialSharingList = ({ title, itemUrl }) => {
  const encodeSharingText = encodeURIComponent(`Check '${title}' op Dumpert `);
  const encodeSharingUrl = encodeURIComponent(itemUrl);

  return [
    {
      label: 'facebook',
      icon: FacebookIcon,
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeSharingUrl}&t=${encodeSharingText}`,
    },
    {
      label: 'whatsapp',
      icon: WhatsAppIcon,
      url: `https://api.whatsapp.com/send?text=${encodeSharingText}${encodeSharingUrl}`,
    },
    {
      label: 'x-twitter',
      icon: XIcon,
      url: `https://twitter.com/intent/tweet?text=${encodeSharingText}&url=${encodeSharingUrl}`,
    },
  ];
};

export const socialLinksList = [
  {
    label: 'facebook',
    icon: FacebookIcon,
    url: 'https://www.facebook.com/dumpertnl',
  },
  {
    label: 'instagram',
    icon: InstagramIcon,
    url: 'https://www.instagram.com/dumpert',
  },
  {
    label: 'youtube',
    icon: YoutubeIcon,
    url: 'https://www.youtube.com/dumpert',
  },
  {
    label: 'x-twitter',
    icon: XIcon,
    url: 'https://www.twitter.com/dumpert',
  },
  {
    label: 'twitch',
    icon: TwitchIcon,
    url: 'https://www.twitch.tv/dumpert?lang=nl',
  },
  {
    label: 'tiktok',
    icon: TikTokIcon,
    url: 'https://www.tiktok.com/@dumpert',
  },
];
